/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type RetrieveSubscriptionRequest = {
  /**
   * The unique identifier of the subscription
   */
  subscriptionId: string;
};

/** @internal */
export const RetrieveSubscriptionRequest$inboundSchema: z.ZodType<
  RetrieveSubscriptionRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  subscription_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "subscription_id": "subscriptionId",
  });
});
/** @internal */
export type RetrieveSubscriptionRequest$Outbound = {
  subscription_id: string;
};

/** @internal */
export const RetrieveSubscriptionRequest$outboundSchema: z.ZodType<
  RetrieveSubscriptionRequest$Outbound,
  z.ZodTypeDef,
  RetrieveSubscriptionRequest
> = z.object({
  subscriptionId: z.string(),
}).transform((v) => {
  return remap$(v, {
    subscriptionId: "subscription_id",
  });
});

export function retrieveSubscriptionRequestToJSON(
  retrieveSubscriptionRequest: RetrieveSubscriptionRequest,
): string {
  return JSON.stringify(
    RetrieveSubscriptionRequest$outboundSchema.parse(
      retrieveSubscriptionRequest,
    ),
  );
}
export function retrieveSubscriptionRequestFromJSON(
  jsonString: string,
): SafeParseResult<RetrieveSubscriptionRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => RetrieveSubscriptionRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'RetrieveSubscriptionRequest' from JSON`,
  );
}
